export enum ViewType {
  OutboundShipments = 3000,
  AgentShipments = 3300,
  Return = 4000,
  AgentReturn = 4300,
}

export enum ClientSetting {
  BusinessFlowType = 'businessFlowType',
  MyShipment = 'myShipment',
  MyShipmentValue = 'myShipmentValue',
  MySelection = 'mySelection',
  ProductPanel = 'productPanel',
  ServiceRequest = 'serviceRequest',
  ServiceRequestExtendAccessPointDays = 'extendAccessPointDays',
  ServiceRequestChangeName = 'changeName',
  ServiceRequestChangeAddress = 'changeAddress',
  ServiceRequestChangePhone = 'changePhone',
  ServiceRequestChangeEmail = 'changeEmail',
  ServiceRequestCancelShipment = 'cancelShipment',
  ServiceRequestChangeDoorAccessCode = 'changeDoorAccessCode',
  ServiceRequestLeaveOutsideDoor = 'leaveOutsideDoor',
  ServiceRequestKnockOnDoor = 'knockOnDoor',
  ServiceRequestNoIdRequirement = 'noIdRequirement',
  ServiceRequestMessageToDriver = 'messageToDriver',
  ServiceRequestChangeLockerLocation = 'lockerLocation',
  ServiceRequestNewDeliveryAttempt = 'newDeliveryAttempt',
  ContextMenu = 'contextMenu',
  ContextMenuSendMessage = 'contextMenuSendMessage',
  ContextMenuServiceRequest = 'contextMenuServiceRequest',
  ContextMenuShowRelated = 'contextMenuShowRelated',
  ContextMenuActions = 'contextMenuActions',
  ContextMenuEditInformation = 'contextMenuEditInformation',
  ContextMenuServices = 'contextMenuServices',
  ViewDateDisplayName = 'viewDateDisplayName',
}

export enum BusinessFlowType {
  B2B = '10',
  B2C = '20',
}

export enum ClientErrorCode {
  Unexpected = 9099,
}
